import React from 'react';
import { FormControl } from 'react-bootstrap';
import PropTypes from 'prop-types';

const Select = ({ value, onChange, editable, options, multiple = false }) => {
  const values = options.map((type, i) => {
    return (
      <option value={type.value} key={i}>
        {type.title}
      </option>
    );
  });

  return (
    <FormControl
      value={value}
      onChange={onChange}
      disabled={!editable}
      componentClass="select"
      multiple={multiple}
    >
      {values}
    </FormControl>
  );
};

Select.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  editable: PropTypes.bool
};

export default Select;



// WEBPACK FOOTER //
// ./src/components/form/Select.js